import { Box, Checkbox, FormControlLabel, Grid, makeStyles, Radio, RadioGroup, Typography } from '@material-ui/core'
import { Add, Delete } from '@material-ui/icons'
import React, { useState } from 'react'
import { handleSelectedItem, isSelected, ROUTES, sortByName, tempMappedModules } from '../../shared/constants'
import { isAllElementsExist, selectDropdown } from '../../utils/otherHelper'
import CustomButton from '../CustomButton'
import { CustomChipInput, CustomInput, CustomSelect } from '../CustomForm'
import CustomHeading from '../CustomHeading'
import HeaderTabLayout from '../HeaderTabLayout'
import Layout from '../Layout'
import CustomAddForm from '../version-4/MasterForms/CustomAddForm'
const useStyles = makeStyles((theme) => ({
  button: {
    width: '100%',
    marginRight: '10px',
  },
  //   danger: {
  //     backgroundColor: 'red',
  //     width: '100%',
  // ​
  //     '&:focus': {
  //       backgroundColor: 'red',
  //     },
  //   },
}))
export default function CustomAddPage({
  loading,
  inputFields,
  setState = () => {},
  state,
  handleClick = () => {},
  redirect,
  currentData,
  heading,
  form,
  modules,
  setModules = () => {},
  tempModule,
  setTempModule = () => {},
  data,
  questions,
  setQuestions = () => {},
  uploadLoading,
  moduleName = [],
  actionName= [],
  mappedModules = tempMappedModules,
}) {
  console.log({ questions })
  if (moduleName.length === 0) moduleName = ['AUDIT', 'EMPLOYEE', 'LEAD', 'SALES', 'PRODUCT', 'LEARNING', 'ORDER', 'TRAVEL_ALLOWANCE', "DEALER_ONBOARDING", "BEAT", "ATTENDANCE"]
  if (actionName.length === 0) actionName = (['CREATE', 'READ', 'UPDATE', 'DELETE', 'UPLOAD', 'FLAG'])
  const classes = useStyles()
  const [selected, setSelected] = React.useState([])
  const [tempCorrectAnswer, setTempCorrectAnswer] = useState('')
  console.log({mappedModules})
  if(mappedModules.length === 0) mappedModules = tempMappedModules;
  console.log('questions : ', tempModule)

  let handleChange = (i, e, chip) => {
    let newFormValues = [...questions]
    if (chip) {
      newFormValues[i]['options'] = [...newFormValues[i]['options'], e]
      setQuestions(newFormValues)
    } else {
      newFormValues[i][e.target.name] = e.target.value
      setQuestions(newFormValues)
    }
  }

  let addFormFields = () => {
    setQuestions([...questions, { question: '', questionType: 'MCQ', options: [], correctAnswer: [] }])
  }

  let removeFormFields = (i) => {
    let newFormValues = [...questions]
    newFormValues.splice(i, 1)
    setQuestions(newFormValues)
  }

  const renderForm = () => {
    if (modules && setModules) {
      return (
        <>
          {/* <CustomAddForm state={form} setState={setForm} data={inputFields} /> */}
          <CustomAddForm state={state} setState={setState} data={inputFields} />
          <br />
          <br />
          <CustomHeading heading="MODULES" />
          <br />
          {/* {Object.keys(tempModules).map((val) => (
            <CheckBoxWithLabel value={val} form={tempModules} setForm={setTempModules} label={val} />
          ))} */}
          ​{console.log("mappedModules ", mappedModules)}
          {/* {mappedModules.map(mapped =>)} */}
          {moduleName.map((val, index) => {
            console.log(tempModule[val], tempModule, val, 'crudval')
            return (
              <>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={tempModule[val] && tempModule[val].length > 0}
                          key={new Date()}
                          name={val}
                          onChange={(e) => {
                            let obj = tempModule
                            if (obj[val]) {
                              delete obj[val]
                            } else {
                              if(mappedModules[index])
                                obj[val] = mappedModules[index][val]
                              else if(mappedModules[val])
                              obj[val] = mappedModules[val];
                              else 
                                obj[val] = ['CREATE', 'READ', 'UPDATE', 'DELETE', 'UPLOAD', 'FLAG']
                            }
                            console.log('OBJ 1 : ', obj)
                            setTempModule(obj)
                          }}
                        />
                      }
                      label={val}
                    />
                <br />
               

                {  mappedModules[val] ? mappedModules[val]?.map((val2) => {
                  console.log(val, " ", mappedModules[val])
                  console.log(val2, 'crudval')
                  // console.log('tempModule[val] && tempModule[val].includes(val2) : ', tempModule)
                  return (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={tempModule[val] && tempModule[val].includes(val2)}
                          key={new Date()}
                          name={val2}
                          onChange={(e) => {
                            let obj = tempModule
                            if (obj[val]) {
                              if (obj[val].includes(val2)) {
                                obj[val] = obj[val].filter((temp) => temp !== val2)
                              } else {
                                obj[val].push(val2)
                              }
                              // delete obj[val]
                            } else {
                              console.log('heret')
                              obj[val] = [val2]
                            }
                            console.log('OBJ 2: ', obj)
                            setTempModule(obj)
                          }}
                        />
                      }
                      label={val2}
                    />
                  )
                }):
                  mappedModules[index] &&  mappedModules[index][val]?.map((val2) => {
                  console.log(val, " ", mappedModules[val])
                  console.log(val2, 'crudval')
                  // console.log('tempModule[val] && tempModule[val].includes(val2) : ', tempModule)
                  return (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={tempModule[val] && tempModule[val].includes(val2)}
                          key={new Date()}
                          name={val2}
                          onChange={(e) => {
                            let obj = tempModule
                            if (obj[val]) {
                              if (obj[val].includes(val2)) {
                                obj[val] = obj[val].filter((temp) => temp !== val2)
                              } else {
                                obj[val].push(val2)
                              }
                              // delete obj[val]
                            } else {
                              console.log('heret')
                              obj[val] = [val2]
                            }
                            console.log('OBJ 2: ', obj)
                            setTempModule(obj)
                          }}
                        />
                      }
                      label={val2}
                    />
                  )
                })}     
                <br />
              </>
            )
          })}
          {/* {Object.entries(modules).map((item) => {
            let value = item[0]
            return (
              <>
                <CheckBoxWithLabel value={item[1].FLAG} form={modules} setForm={setModules} label={value} name={'FLAG'} />
                <br />
                {Object.keys(modules[value]).map((val) => {
                  return <>{val !== 'FLAG' && <CheckBoxWithLabel value={item[1][val]} form={modules} setForm={setModules} label={item[0]} name={val} />}</>
                })}
                <br />
              </>
            )
          })} */}
        </>
      )
    } else {
      return <CustomAddForm state={state} setState={setState} data={inputFields} />
    }
  }
  const AssesmentForm = () => {
    const inputValues = [
      { label: 'Quiz Name', value: state.name, name: 'name' },
      { label: 'Training Category', value: state.trainingCategory, name: 'trainingCategory', options: sortByName([], 'name'), ...selectDropdown },
      {
        label: 'Category Content',
        value: state.trainingCategoryContent,
        name: 'trainingCategoryContent',
        options: sortByName([], 'name'),
        ...selectDropdown,
        disabled: state.trainingCategory ? false : true,
      },
      { label: 'Start Date', value: state.startDate, name: 'startDate', type: 'DATE' },
      { label: 'Expiry Date', value: state.expiryDate, name: 'expiryDate', type: 'DATE' },
      // { label: 'Action', value: state.status, name: 'status', options: ['PUBLISHED', 'UNPUBLISHED', 'EXPIRED'] },
      // { label: 'Total Questions', value: state.totalQuestions, name: 'totalQuestions', type: 'NUMBER' },
      { label: 'Status', value: state.active, type: 'ACTIVE' },
      // ...questionForm,
    ]
    return (
      <>
        <CustomAddForm state={state} setState={setState} data={inputValues} />
        {questions.map((item, index1) => {
          const allCorrectAnswers = isAllElementsExist(item.options, [...selected, ...item.correctAnswer])
          return (
            <React.Fragment>
              <Box display="flex" justifyContent="space-between" marginTop="40px" alignItems="center">
                <CustomHeading heading={`Question ${index1 + 1}`} />
                <Box display="flex">
                  {questions.length - 1 === index1 && <CustomButton text="Add" icon={<Add />} handleSubmit={addFormFields} className={classes.button} />}
                  {questions.length !== 1 ? <CustomButton text="Remove" handleSubmit={removeFormFields} icon={<Delete />} className={`${classes.button} ${classes.danger}`} /> : null}
                </Box>
              </Box>
              <CustomInput label="Question" value={item.question} name="question" onChange={(e) => handleChange(index1, e)} fullWidth />
              <CustomSelect value={item.questionType} label="Question Type" options={['MCQ', 'BOOLEAN']} onChange={(e) => handleChange(index1, e)} name="questionType" />
              <CustomChipInput
                value={item.options}
                label="Enter Options"
                name="options"
                grid="12"
                onChange={(e) => handleChange(index1, e, 'chip')}
                onDelete={(chip, index1) => {
                  let newFormValues = [...questions]
                  console.log(newFormValues)
                  console.log(newFormValues[index1]['options'])
                  let arr = newFormValues ? newFormValues[index1]['options'] : []
                  arr = arr.filter((val, i) => index1 !== i)
                  newFormValues[index1]['options'] = [...arr]
                  setQuestions(newFormValues)
                }}
              />
              <br />
              <br />​
              {item.options.length > 0 && (
                <Grid container>
                  <Grid item lg={5}>
                    <Typography style={{ fontWeight: 600, fontSize: '14px' }}>Options</Typography>​
                    <Grid container>
                      {item.options.map((val, index) => {
                        console.log('VAL : ', val)
                        let isSelect = isSelected(val, selected)
                        return (
                          <Grid item lg={6}>
                            {item.questionType === 'MCQ' || item.questionType === '' ? (
                              <FormControlLabel control={<Checkbox checked={isSelect} onClick={() => handleSelectedItem(val, selected, setSelected)} name="options" />} label={val} />
                            ) : (
                              <RadioGroup
                                aria-label="gender"
                                name="correctAnswer"
                                value={item.correctAnswer[0]}
                                // onChange={(e) => handleChange(index, e)}
                                onChange={(e) => {
                                  console.log('newFormValues : ', e.target.value)
                                  let newFormValues = [...questions]
                                  newFormValues[index1]['correctAnswer'] = [e.target.value]
                                  console.log('newFormValues 2: ', newFormValues)
                                  setQuestions(newFormValues)
                                }}
                              >
                                <FormControlLabel value={val} control={<Radio />} label={val} />
                              </RadioGroup>
                            )}
                            {/*  */}
                          </Grid>
                        )
                      })}
                      <Grid item lg={12}>
                        {item.questionType === 'MCQ' || item.questionType === '' ? (
                          <CustomChipInput value={allCorrectAnswers} label="Correct Answers" name="options" disabled={true} />
                        ) : (
                          <Box marginTop="30px" display="flex">
                            <Typography style={{ fontSize: '14px', marginRight: '10px' }}>Correct Answer </Typography>
                            <strong> : {item.correctAnswer[0]}</strong>
                          </Box>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </React.Fragment>
          )
        })}
      </>
    )
  }
  return (
    <Layout heading={heading} heading2={currentData ? 'Edit' : 'Add'} url1={ROUTES[redirect]} none uploadLoading={uploadLoading}>
      <HeaderTabLayout
        heading={`${currentData ? 'Edit' : 'Add'} ${heading}`}
        content={questions ? <AssesmentForm /> : form ? form : renderForm()}
        addContent={handleClick}
        redirect={ROUTES[redirect]}
        state={heading !== 'Training Category Content' && state}
        loading={loading}
        setState = {setState}
      />
    </Layout>
  )
}
